<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">
                        <span class="font-weight-bold" v-if="vehicle && vehicle.plate && vehicle.usage">
                            {{ vehicle.usage.name }} - {{vehicle.plate.initials}} {{vehicle.plate.number}}
                        </span>
                    </h4>
                    <p class="text-subtitle-1">{{$t("vehicle_information")}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.vehicle.update)">
                    <v-btn block depressed @click="handleUpdate">
                        <v-icon left>mdi-pencil</v-icon>
                        {{$t("update_information")}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3"  v-if="hasPermission(permissions.vehicle.delete)">
                    <v-btn block depressed color="error--text" @click="handleRemove" :loading="removeLoading">
                        <v-icon left>mdi-archive-arrow-down</v-icon>
                        {{$t("archive")}}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <!-- <tr>
                                <th>{{$t("plate")}}</th>
                                <td>
                                    <span v-if="vehicle && vehicle.plate">
                                        {{vehicle.plate.initials}} {{vehicle.plate.number}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t("plate_type")}}</th>
                                <td>
                                    <span v-if="vehicle && vehicle.plate">
                                        {{vehicle.plate.type}}
                                    </span>
                                </td>
                            </tr> -->
                            <tr>
                                <th>{{$t("unit_number")}}</th>
                                <td>{{vehicle ? vehicle.unit_number : null}}</td>
                            </tr>
                            <tr>
                                <th>{{$t("brand")}}/ {{$t("model")}}</th>
                                <td>
                                    <span v-if="vehicle && vehicle.model && vehicle.model.brand">
                                        {{vehicle.model.brand.name}} / {{vehicle.model.name}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t("manufacture_year")}}</th>
                                <td>
                                    <span>
                                        {{vehicle.manufacture_year}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{$t("vehicle_type")}}</th>
                                <td>
                                    <span v-if="vehicle && vehicle.usage">
                                        {{vehicle.usage.name}}
                                    </span>
                                </td>
                            </tr>
                            <!-- <tr>
                                <th>Engine Number</th>
                                <td>
                                    <span v-if="vehicle">
                                        {{vehicle.engine_number}}
                                    </span>
                                </td>
                            </tr> -->
                            <tr>
                                <th>VIN</th>
                                <td>
                                    <span v-if="vehicle">
                                        {{vehicle.vin}}
                                    </span>
                                </td>
                            </tr>
                            <!-- <tr>
                                <th>Dimension</th>
                                <td>
                                    <span v-if="vehicle && vehicle.dimension">
                                        {{vehicle.dimension.name}}
                                    </span>
                                </td>
                            </tr> -->
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
            <!-- <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Created By</th>
                                <td>{{ vehicle && vehicle.created_by ? `${vehicle.created_by.first_name} ${vehicle.created_by.last_name}` : null }}</td>
                            </tr>
                            <tr>
                                <th>Created At</th>
                                <td>{{ vehicle ? vehicle.created_at : null }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Updated By</th>
                                <td>{{ vehicle && vehicle.updated_by ? `${vehicle.updated_by.first_name} ${vehicle.updated_by.last_name}` : null }}</td>
                            </tr>
                            <tr>
                                <th>Updated At</th>
                                <td>{{ vehicle ? vehicle.updated_at : null }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row> -->
            <v-row>
                <v-col>
                    <v-tabs v-model="tab0">
                        <v-tab>{{$t("insurance")}}</v-tab>
                        <v-tab>{{$t("traffic_license")}}</v-tab>
                        <!-- <v-tab>{{$t("pledge_information")}}</v-tab>
                        <v-tab>{{$t("machinery")}}</v-tab>
                        <v-tab>{{$t("attachments")}}</v-tab>
                        <v-tab>{{$t("accounting")}}</v-tab>
                        <v-tab>{{$t("fixed_asset")}}</v-tab> -->
                    </v-tabs>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <router-view></router-view>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-3"/>
                    <v-skeleton-loader type="text" class="my-3"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="me-5"/>
                    <v-skeleton-loader type="button"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="mt-6"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div>
                        <v-skeleton-loader type="text" class="my-3"/>
                        <v-skeleton-loader type="text" class="my-3"/>
                    </div>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import vehicleAPI from './../../services/fleet/vehicle'
import PAlert from './../../components/common/PAlert.vue';
import permissions from '../../data/permissions';
import authorize from '../../utils/authorize';
export default {
    components: {
        PAlert
    },
    data() {
        return {
            vehicle: {},
            id: null,
            loading: false,
            removeLoading: false,
            alert: {
                title: this.$t("alert_title"),
                content: "",
                callback: null,
                model: false
            },
            permissions,
            tab0: 0
        }
    },
    computed: {
    },
    watch: {
        tab0: {
            handler() {
                this.handleTabNagivation();
            }
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetchVehicle() {
            this.loading = true;
            vehicleAPI.get(this.id).then(response => {
                this.vehicle = response.data;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleUpdate() {
            this.$router.push({
                name: "VehicleEdit",
                params: {
                    vehicleID: this.id
                }
            })
        },
        handleRemove() {
            this.alert = {...this.alert, content: this.$t("are_you_sure_you_want_to_delete"), model: true, callback: this.remove}
        },
        remove() {
            this.removeLoading = true;
            vehicleAPI.remove(this.id).then(() => {
                this.$router.replace({ name: "VehiclesList" })
            }).finally(() => {
                this.removeLoading = false;
            })
        },
        handleTabNagivation() {
            switch(this.tab0) {
                case 0:
                    this.$router.push({path: `/fleet/vehicle/${this.id}/insurance`});
                    break;
                case 1:
                    this.$router.push({path: `/fleet/vehicle/${this.id}/license`});
                    break;
                case 2:
                    this.$router.push({path: `/fleet/vehicle/${this.id}`});
                    break;
                default:
                    this.$router.push({path: `/fleet/vehicle/${this.id}`});
            }
        }
    },
    created() {
        this.id = this.$route.params.vehicleID;
        this.fetchVehicle();
        this.handleTabNagivation();
    }
}
</script>

<style>

</style>